import * as tus from "tus-js-client";
import api from "@/lib/api";

// Resumable browser → Bunny Stream upload. `onProgress(sentBytes)` per chunk.
export async function uploadToBunny(filmId, kind, file, onProgress) {
  const { data: s } = await api.post(`/bunny/films/${filmId}/upload-session`, { kind });
  await new Promise((resolve, reject) => {
    const upload = new tus.Upload(file, {
      endpoint: s.endpoint,
      retryDelays: [0, 3000, 5000, 10000, 20000, 60000],
      chunkSize: 50 * 1024 * 1024,
      removeFingerprintOnSuccess: true,
      headers: {
        AuthorizationSignature: s.signature,
        AuthorizationExpire: String(s.expires),
        VideoId: s.video_id,
        LibraryId: String(s.library_id),
      },
      metadata: { filetype: file.type || "video/mp4", title: file.name },
      onProgress: (sent) => onProgress?.(sent),
      onError: reject,
      onSuccess: resolve,
    });
    upload.findPreviousUploads().then((prev) => {
      if (prev.length) upload.resumeFromPreviousUpload(prev[0]);
      upload.start();
    });
  });
  await api.post(`/bunny/films/${filmId}/upload-complete`, { kind });
  return s.video_id;
}
